import { TelemetryEvent } from '@ms/oteljs';
import { getAriaEvent } from '@ms/oteljs-aria/dist/src/GetAriaEvent';
import { addOTelColumnDataEventAppPinning } from 'owa-addins-analytics';
import { lazyGetOTelAddinsLogger } from 'owa-analytics';
import { ariaTenantToken, nexusTenantToken } from './tokenConstants';
import { ExtensibilityModeEnum } from 'owa-addins-types';

export async function logAppPinningTelemetry(
    addinId: string,
    isPinned: boolean,
    extMode: ExtensibilityModeEnum
): Promise<void> {
    let event: TelemetryEvent = {
        eventName: 'Office.Extensibility.Host.AppPinning',
        telemetryProperties: {
            ariaTenantToken: ariaTenantToken,
            nexusTenantToken: nexusTenantToken,
        },
        // TODO (sagaikwa) eventFlags need to be set. Need to update oteljs package first.
    };
    const logger = await lazyGetOTelAddinsLogger(event.telemetryProperties.ariaTenantToken);
    const ariaEvent = getAriaEvent(event, [], Date.now());
    addOTelColumnDataEventAppPinning(ariaEvent, addinId, isPinned, extMode);
    logger.logEvent(ariaEvent);
}
